import React, { useEffect } from 'react';
import { WebChatChannelEditor } from '../../components/webChat';
import { Typography } from 'antd';
import {
  clearWebChatChannelData,
  setDefaultsForNewWebchatChannel,
} from '../../../../reduxToolkit/channelSlice';
import { useDispatch } from 'react-redux';
const { Title } = Typography;

const CreateNewChannel = () => {
  // hooks
  const dispatch = useDispatch();

  // useEffects
  useEffect(() => {
    dispatch(clearWebChatChannelData());
    dispatch(setDefaultsForNewWebchatChannel());
  }, []);

  return (
    <div className="grid grid-rows-[auto_1fr] gap-3 h-dvh *:rounded-lg overflow-hidden">
      <Title level={5} style={{ marginBottom: '6px' }}>
        Create New Channel
      </Title>
      <div className="bg-white overflow-auto shadow-sm">
        <WebChatChannelEditor type="create" />
      </div>
    </div>
  );
};

export default CreateNewChannel;
